"use client";

import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { DropInteractionParams, DropLocation } from "../Drop";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { useCallback, useState } from "react";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import WaveDropActions from "../WaveDropActions";
import WaveDropMobileMenu from "../WaveDropMobileMenu";
import WaveDropAuthorPfp from "../WaveDropAuthorPfp";
import ParticipationDropContainer from "./ParticipationDropContainer";
import ParticipationDropHeader from "./ParticipationDropHeader";
import ParticipationDropContent from "./ParticipationDropContent";
import ParticipationDropMetadata from "./ParticipationDropMetadata";
import ParticipationDropFooter from "./ParticipationDropFooter";
interface OngoingParticipationDropProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: (drop: ExtendedDrop) => void;
  readonly parentContainerRef?: React.RefObject<HTMLElement | null>;
}
export default function OngoingParticipationDrop(t0) {
  const $ = _c(59);
  const {
    drop,
    showWaveInfo,
    activeDrop,
    showReplyAndQuote,
    location,
    onReply,
    onQuote,
    onQuoteClick,
    onDropContentClick,
    parentContainerRef
  } = t0;
  const isActiveDrop = activeDrop?.drop.id === drop.id;
  const isMobile = useIsMobileDevice();
  const [activePartIndex, setActivePartIndex] = useState(0);
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const [isSlideUp, setIsSlideUp] = useState(false);
  let t1;
  if ($[0] !== isMobile) {
    t1 = () => {
      if (!isMobile) {
        return;
      }
      setLongPressTriggered(true);
      setIsSlideUp(true);
    };
    $[0] = isMobile;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLongPress = t1;
  let t2;
  if ($[2] !== activePartIndex || $[3] !== drop || $[4] !== onReply) {
    t2 = () => {
      setIsSlideUp(false);
      onReply({
        drop,
        partId: drop.parts[activePartIndex].part_id
      });
    };
    $[2] = activePartIndex;
    $[3] = drop;
    $[4] = onReply;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleOnReply = t2;
  let t3;
  if ($[6] !== activePartIndex || $[7] !== drop || $[8] !== onQuote) {
    t3 = () => {
      setIsSlideUp(false);
      onQuote({
        drop,
        partId: drop.parts[activePartIndex].part_id
      });
    };
    $[6] = activePartIndex;
    $[7] = drop;
    $[8] = onQuote;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleOnQuote = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsSlideUp(false);
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleOnAddReaction = t4;
  let t5;
  if ($[11] !== activePartIndex || $[12] !== drop || $[13] !== handleOnQuote || $[14] !== handleOnReply || $[15] !== isMobile || $[16] !== showReplyAndQuote) {
    t5 = !isMobile && showReplyAndQuote && <WaveDropActions drop={drop} activePartIndex={activePartIndex} showVoting={false} onReply={handleOnReply} onQuote={handleOnQuote} />;
    $[11] = activePartIndex;
    $[12] = drop;
    $[13] = handleOnQuote;
    $[14] = handleOnReply;
    $[15] = isMobile;
    $[16] = showReplyAndQuote;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== drop) {
    t6 = <WaveDropAuthorPfp drop={drop} />;
    $[18] = drop;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== drop || $[21] !== showWaveInfo) {
    t7 = <ParticipationDropHeader drop={drop} showWaveInfo={showWaveInfo} />;
    $[20] = drop;
    $[21] = showWaveInfo;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== activePartIndex || $[24] !== drop || $[25] !== handleLongPress || $[26] !== onDropContentClick || $[27] !== onQuoteClick || $[28] !== parentContainerRef) {
    t8 = <ParticipationDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={handleLongPress} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} setLongPressTriggered={setLongPressTriggered} parentContainerRef={parentContainerRef} isCompetitionDrop={true} />;
    $[23] = activePartIndex;
    $[24] = drop;
    $[25] = handleLongPress;
    $[26] = onDropContentClick;
    $[27] = onQuoteClick;
    $[28] = parentContainerRef;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== t7 || $[31] !== t8) {
    t9 = <div className="tw-flex tw-flex-col tw-w-full tw-gap-y-1.5">{t7}{t8}</div>;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t6 || $[34] !== t9) {
    t10 = <div className="tw-flex tw-gap-x-3 tw-relative tw-z-10 tw-w-full tw-text-left tw-bg-transparent tw-border-0 tw-px-4 tw-pt-4">{t6}{t9}</div>;
    $[33] = t6;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== drop.id || $[37] !== drop.metadata) {
    t11 = <ParticipationDropMetadata metadata={drop.metadata} contextId={drop.id} />;
    $[36] = drop.id;
    $[37] = drop.metadata;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== drop) {
    t12 = <ParticipationDropFooter drop={drop} />;
    $[39] = drop;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== t11 || $[42] !== t12) {
    t13 = <div className="tw-flex tw-w-full tw-flex-col">{t11}{t12}</div>;
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== drop || $[45] !== handleOnQuote || $[46] !== handleOnReply || $[47] !== isSlideUp || $[48] !== longPressTriggered || $[49] !== showReplyAndQuote) {
    t14 = <WaveDropMobileMenu drop={drop} isOpen={isSlideUp} longPressTriggered={longPressTriggered} showReplyAndQuote={showReplyAndQuote} setOpen={setIsSlideUp} onReply={handleOnReply} onQuote={handleOnQuote} onAddReaction={handleOnAddReaction} />;
    $[44] = drop;
    $[45] = handleOnQuote;
    $[46] = handleOnReply;
    $[47] = isSlideUp;
    $[48] = longPressTriggered;
    $[49] = showReplyAndQuote;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  let t15;
  if ($[51] !== drop || $[52] !== isActiveDrop || $[53] !== location || $[54] !== t10 || $[55] !== t13 || $[56] !== t14 || $[57] !== t5) {
    t15 = <ParticipationDropContainer drop={drop} isActiveDrop={isActiveDrop} location={location}>{t5}{t10}{t13}{t14}</ParticipationDropContainer>;
    $[51] = drop;
    $[52] = isActiveDrop;
    $[53] = location;
    $[54] = t10;
    $[55] = t13;
    $[56] = t14;
    $[57] = t5;
    $[58] = t15;
  } else {
    t15 = $[58];
  }
  return t15;
}